import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ButtonComponent from "../Components/ButtonComponent";
import { FormInput } from "../Components/FormInput";
import TextArea from "../Components/TextArea";
import { createReviewEmail } from "../Services/Service";

export default function SendWelcomeEmail(props) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setloading] = useState(false);

  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size="xl">
        <Formik
          enableReinitialize={true}
          initialValues={{
            name: "",
            email: "",
          }}
          // validationSchema={Yup.object({
          //   //   email: Yup.string().required("Enter Email"),
          // })}
          onSubmit={async (values, { setSubmitting }) => {
            var answer = window.confirm("Create email for review?");
            if (answer) {
              try {
                setloading(true);
                await createReviewEmail({
                  name: values.name,
                  email: values.email,
                  course: values.course,
                  courseType: values.courseType,
                  startDate: startDate,
                  endDate: endDate,
                  time: values.time,
                  tutorialLink: values.tutorialLink,
                  classLink: values.classLink,
                  classUser: values.classUser,
                  classPassword: values.classPassword,
                  courseTutorialLink: values.courseTutorialLink,
                  materialLink: values.materialLink,
                  ebookLink: values.ebookLink,
                });
                props.onHide();
                await props.emailsUpdated();
                props.setShow(true);
                setTimeout(() => props.setShow(false), 5000);
                setloading(false);
              } catch (error) {
                setloading(false);
                alert(error.message);
              }
            } else {
              //some code
            }
          }}
        >
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Send Welcome Email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ paddingBottom: 20 }}>
                <span className="send-email-header">المعلومات الشخصية</span>
                <div className="d-flex flex-row">
                  <FormInput
                    placeholder="Name"
                    containerStyle={{ marginRight: 10 }}
                    name="name"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="الاسم"
                  />
                  <FormInput
                    placeholder="Email"
                    containerStyle={{ marginRight: 10 }}
                    name="email"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="الإيميل"
                  />
                </div>
              </div>
              <div style={{ paddingBottom: 20 }}>
                <span className="send-email-header">تفاصيل الدورة</span>
                <div className="d-flex flex-row">
                  <FormInput
                    placeholder="Course"
                    containerStyle={{ marginRight: 10 }}
                    name="course"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="نوع الدورة"
                  />
                  <FormInput
                    placeholder="Course Type"
                    containerStyle={{ marginRight: 10 }}
                    name="courseType"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="نوع الدراسة"
                  />
                  <div style={{ margin: "5px 0 10px 12px" }}>
                    <div
                      className="input-title"
                      style={{ marginBottom: 4, color: "#333" }}
                    >
                      {"موعد بداية الدورة"}
                    </div>
                    <DatePicker
                      selected={startDate}
                      placeholderText="Start Date"
                      onChange={(date) => setStartDate(date)}
                    />
                  </div>
                  <div style={{ margin: "5px 0 10px 12px" }}>
                    <div
                      className="input-title"
                      style={{ marginBottom: 4, color: "#333" }}
                    >
                      {"موعد نهاية الدورة"}
                    </div>
                    <DatePicker
                      selected={endDate}
                      placeholderText="End Date"
                      onChange={(date) => setEndDate(date)}
                    />
                  </div>
                  <TextArea
                    name="time"
                    type="text"
                    placeholder={"Time"}
                    style={{ marginBottom: 4, color: "#333" }}
                    rows={"1"}
                    onChange={() => {
                      // someFuncton();
                    }}
                    label="الأيام والوقت"
                  />
                </div>
              </div>
              <div style={{ paddingBottom: 20 }}>
                <span className="send-email-header"> خطوات الانضمام للحصص</span>{" "}
                <div className="d-flex flex-row">
                  <FormInput
                    placeholder="Tutorial Video Link"
                    containerStyle={{ marginRight: 10 }}
                    name="tutorialLink"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="مشاهدة الفيديو الإرشادي"
                  />

                  <FormInput
                    placeholder="Class Link"
                    containerStyle={{ marginRight: 10 }}
                    name="classLink"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="الدخول على الرابط التالي"
                  />
                  <FormInput
                    placeholder="Class User Name"
                    containerStyle={{ marginRight: 10 }}
                    name="classUser"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="اسم المستخدم"
                  />
                  <FormInput
                    placeholder="Class Password"
                    containerStyle={{ marginRight: 10 }}
                    name="classPassword"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="كلمة السر "
                  />
                </div>
              </div>
              <div style={{ paddingBottom: 20 }}>
                <span className="send-email-header">
                  المواد الالكترونية الخاصة بالدورة
                </span>
                <div className="d-flex flex-row">
                  <FormInput
                    placeholder="Course Tutorial Link"
                    containerStyle={{ marginRight: 10 }}
                    name="courseTutorialLink"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="مشاهدة الفيديو الإرشادي"
                  />

                  <FormInput
                    placeholder="Material Link"
                    containerStyle={{ marginRight: 10 }}
                    name="materialLink"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="رابط المواد الاكترونية"
                  />
                  <FormInput
                    placeholder="E-book Link"
                    containerStyle={{ marginRight: 10 }}
                    name="ebookLink"
                    type="text"
                    style={{ marginBottom: 4, color: "#333" }}
                    label="رابط الكتب"
                  />
                </div>
              </div>
              <div className="d-flex flex-row" style={{ marginTop: 36 }}>
                <ButtonComponent
                  disable={loading}
                  text="Create"
                  type="submit"
                  noOnclick
                  // onClick={() => setmodalShow(true)}
                />
                <ButtonComponent
                  text="Cancel"
                  style={{
                    marginLeft: 16,
                    color: "#3F4247",
                    backgroundColor: "#fff",
                    border: "1px solid #D7DFE9",
                  }}
                  onClick={() => props.onHide()}
                />
              </div>
              {/* <YNModels
                loading={loading}
                show={modalShow}
                onHide={() => setmodalShow(false)}
              /> */}
            </Modal.Body>
          </Form>
        </Formik>
      </Modal>
    </div>
  );
}
